import axios from 'axios';

export const getCheckPhone = phone =>
  axios(`${process.env.REACT_APP_CHECK_PHONE_API_URL}/${phone}`).then(({ data }) => data);

export const getCheckMail = mail =>
  axios.post(`${process.env.REACT_APP_CHECK_EMAIL_API_URL}`, { emailToCheck: mail }).then(({ data }) => data);

export default { getCheckPhone, getCheckMail };
